export const NOT_LOGGED_IN_MESSAGE = "ログイン状態を確認できませんでした。もう一度お試しください。改善しない場合は再ログインしてください。";
export const REJECTED_MESSAGE = "入力内容を確認して、もう一度お試しください。";
export const UNKNOWN_RESULT_MESSAGE = "処理結果を確認できませんでした。ポイント履歴をご確認のうえ、反映されていない場合は、もう一度お試しください。";

/** 利用者にそのまま表示してよい日本語メッセージを持つエラー */
export class PointRequestError extends Error {}

async function readStatusMessage(response: Response): Promise<string | null> {
    const errorData = await response.json().catch(() => null);
    const statusMessage = errorData?.result?.statusMessage;
    return typeof statusMessage === "string" && statusMessage !== "" ? statusMessage : null;
}

/**
 * 2xx 以外の応答を PointRequestError にして throw する。
 * 4xx は API が DB に触る前に弾いた（確定的に未実行）ので再試行を促す文言、
 * 5xx はサーバー側で処理済みか分からないので履歴の確認を促す文言にする。
 */
export async function assertPointResponseOk(response: Response): Promise<void> {
    if (response.ok) {
        return;
    }
    if (response.status === 401) {
        throw new PointRequestError(await readStatusMessage(response) ?? NOT_LOGGED_IN_MESSAGE);
    }
    if (response.status >= 400 && response.status < 500) {
        throw new PointRequestError(await readStatusMessage(response) ?? REJECTED_MESSAGE);
    }
    throw new PointRequestError(UNKNOWN_RESULT_MESSAGE);
}

export function toPointErrorMessage(e: unknown): string {
    return e instanceof PointRequestError ? e.message : UNKNOWN_RESULT_MESSAGE;
}

type PointRequestHandlers = {
    setErrorMessage: (message: string | null) => void;
    setIsBlocking: (isBlocking: boolean) => void;
};

/** 寄付・ギフトカード交換の実行中はブロックし、失敗時は利用者向けの文言を表示する */
export async function runPointRequest(action: () => Promise<void>, { setErrorMessage, setIsBlocking }: PointRequestHandlers): Promise<void> {
    setErrorMessage(null);
    setIsBlocking(true);
    try {
        await action();
    } catch (e) {
        setErrorMessage(toPointErrorMessage(e));
    } finally {
        setIsBlocking(false);
    }
}
